import api from '../http-common';

const index = (data) =>
  api.post('/feed-products/index', data);

const getOptionsData = () =>
  api.post('/feed-products/get-options-data');

const store = (data) =>
  api.post('/feed-products/store', data);

const edit = (id: number) =>
  api.post(`/feed-products/${id}/edit`);

const update = (id: number, data) =>
  api.post(`/feed-products/${id}/update`, data);

export const FeedProductService = {
  index,
  getOptionsData,
  store,
  edit,
  update
};
